import { graphql } from 'gql';

export const workOrderPricesGql = graphql(`
    query uerWorkOrderPrices(
        $skip: Int
        $take: Int
        $workOrderId: Long!
        $workOrderObjectId: Long!
        $chapter: ChapterEnum!
        $where: WorkOrderPriceDataFilterInput
    ) {
        uerWorkOrderPrices(
            skip: $skip
            take: $take
            workOrderId: $workOrderId
            workOrderObjectId: $workOrderObjectId
            chapter: $chapter
            where: $where
        ) {
            items {
                id
                parentId
                type
                status
                uerId
                uerCode
                uerCodeId
                priceListId
                code
                name
                groupName
                shortName
                rationale
                unit
                unitCost
                hasDuplicates
                totalPlanVolume
                totalPlanCost
                totalCompletedVolume
                totalCompletedCost
                totalRemainderVolume
                totalRemainderCost
                seasonPrices {
                    id
                    seasonId
                    planVolume
                    planVolumeTerms
                    planCost
                    completedVolume
                    completedCost
                    remainderVolume
                    remainderCost
                }
                actKC2Prices {
                    acceptedCost
                    acceptedVolume
                    acceptedVolumeDeviation
                    actKC2Id
                    hasDistributionOfMtrInflation
                    id
                    inflationSeasonId
                    isCorrection
                    isEditableCost
                    isInactive
                    isReadOnly
                    planCost
                    planVolume
                    planVolumeDeviation
                }
                isActKC2Price
                hasEmptySeasonVolume
                hasEmptyActPlanVolume
                hasEmptyActAcceptedVolume
                isExcludedPrice
                hasCostPlan
                workCode
                workCompleted
                workInSum
                workName
                workPlan
                workRatio
                workReminder
                workUnit
            }
            totalCount
        }
    }
`);

export const workOrderPriceActKC2Gql = graphql(`
    query uerWorkOrderActsKC2($workOrderId: Long!, $workOrderRootObjectId: Long!, $actCostGroup: CostGroupEnum!) {
        uerWorkOrderActsKC2(
            workOrderId: $workOrderId
            workOrderRootObjectId: $workOrderRootObjectId
            actCostGroup: $actCostGroup
        ) {
            items {
                id
                objectId
                number
                date
                status
                seasonId
                planVolumeDeviation
                acceptedVolumeDeviation
                planCostDeviation
                acceptedCostDeviation
                isDistributionOfMtrInflation
                correctionNumber
                fullNumber
                isCorrection
                isInactive
                canCreateCorrection
                correctionDate
                costGroup
                inflationSeasonId
                inflationSeasonYear
                reportingFinishDate
                reportingStartDate
                seasonYear
                isSKzSUpdated
                isSKzSCopied
                isSKzSCopyLock
                isSKzS
                objectId
                seasonYear
                statusSKzS
            }
        }
    }
`);

export const gqlWorkOrder = graphql(`
    query uerWorkOrder($workOrderId: Long!) {
        uerWorkOrder(workOrderId: $workOrderId) {
            data {
                id
                name
                internalNumber
                subject
                status
                contractor
                contractorAddress
                signingDate
                amountWithTax
                amountWithoutTax
                remainder
                tax
                startDate
                finishDate
                inflationData {
                    id
                    year
                    inflationRate
                }
                vorType
                statusFollowers
                workOrderChange {
                    id
                    internalNumber
                    signingDate
                }
            }
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const gqlWorkOrderVorTypeAndStatusFollowers = graphql(`
    query uerWorkOrderVorType($workOrderId: Long!) {
        uerWorkOrder(workOrderId: $workOrderId) {
            data {
                vorType
                statusFollowers
            }
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const gqlUpdateWorkOrder = graphql(`
    mutation uerUpdateWorkOrder(
        $id: Long!
        $status: WorkOrderStatusEnum!
        $internalNumber: String
        $signingDate: DateTime!
        $startDate: DateTime!
        $finishDate: DateTime!
        $subject: String
    ) {
        uerUpdateWorkOrder(
            workOrderInput: {
                id: $id
                status: $status
                internalNumber: $internalNumber
                signingDate: $signingDate
                startDate: $startDate
                finishDate: $finishDate
                subject: $subject
            }
        ) {
            data {
                id
                name
                internalNumber
                subject
                status
                contractor
                contractorAddress
                signingDate
                amountWithTax
                amountWithoutTax
                tax
                startDate
                finishDate
            }
            result
            message
            validation {
                message
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);

export const gqlWorkOrderConstructionTypes = graphql(`
    query uerWorkOrderConstructionTypes($workOrderId: Long!) {
        uerWorkOrderConstructionTypes(workOrderId: $workOrderId) {
            id
            code
            name
            shortName
            catalogId
            fullName
        }
    }
`);

export const gqlWorkOrderObjects = graphql(`
    query uerWorkOrderObjects($workOrderId: Long!, $where: WorkOrderObjectDataFilterInput) {
        uerWorkOrderObjects(workOrderId: $workOrderId, where: $where) {
            objectUniqueId
            id
            parentId
            code
            name
            isLeaf
            workOrderId
            rootObjectId
            fromWorkOrder
            fromWorkOrderVOR
            hasActsKC2
            hasCompletedSkzsActsKC2
            constructionType {
                id
                code
                name
                shortName
                catalogId
                fullName
                contractFileName
                createdAt
            }
            contractObject {
                id
                name
                status
                parentId
                rootObjectId
                fromVOR
                constructionType {
                    id
                    code
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                contractId
            }
        }
    }
`);

export const gqlWorkOrderMtrPriceList = graphql(`
    query uerWorkOrderPriceListMtr(
        $workOrderPriceId: Long!
        $where: PriceListMtrRowDataFilterInput
        $skip: Int
        $take: Int
        $order: [PriceListMtrRowDataSortInput!]
    ) {
        uerWorkOrderPriceListMtr(
            workOrderPriceId: $workOrderPriceId
            where: $where
            skip: $skip
            take: $take
            order: $order
        ) {
            items {
                code
                contractId
                id
                isIncludedInAct
                isIncludedInWorkOrder
                justification
                mtrType
                name
                note
                pricingType
                status
                supplyBasis
                supplyBy
                unit
                unitCost
                unitWeight
                volume
            }
            totalCount
        }
    }
`);

export const gqlAddMtrToWorkOrderFromPriceList = graphql(`
    mutation uerAddMtrToWorkOrderFromPriceList($workOrderPriceId: Long!, $mtrRowIds: [Long!]!) {
        uerAddMtrToWorkOrderFromPriceList(workOrderPriceId: $workOrderPriceId, mtrRowIds: $mtrRowIds) {
            data
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const gqlAddMtrToActKC2PriceList = graphql(`
    mutation uerAddMtrToActKC2PriceList($workOrderPriceId: Long!, $mtrInputs: [PriceListMtrRowInput!]!) {
        uerAddMtrToActKC2PriceList(workOrderPriceId: $workOrderPriceId, mtrInputs: $mtrInputs) {
            data
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const qglRemovePriceFromWorkOrder = graphql(`
    mutation uerRemovePriceFromWorkOrder($workOrderPriceIds: [Long!]!) {
        uerRemovePriceFromWorkOrder(workOrderPriceIds: $workOrderPriceIds) {
            data
            result
            message
            validation {
                property
                message
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);

export const qglRemoveActKC2PriceFromWorkOrder = graphql(`
    mutation uerRemoveActKC2PriceFromWorkOrder($workOrderPriceIds: [Long!]!) {
        uerRemoveActKC2PriceFromWorkOrder(workOrderPriceIds: $workOrderPriceIds) {
            data
            result
            message
            validation {
                property
                message
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);

export const removeActKC2OtherFromWorkOrder = graphql(`
    mutation uerRemoveActKC2OtherFromWorkOrder($workOrderOtherPriceIds: [Long!]!) {
        uerRemoveActKC2OtherFromWorkOrder(workOrderOtherPriceIds: $workOrderOtherPriceIds) {
            data
            result
            message
            validation {
                property
                message
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);

export const gqlRemoveOtherFromOrder = graphql(`
    mutation uerRemoveOtherFromWorkOrder($workOrderOtherPriceIds: [Long!]!) {
        uerRemoveOtherFromWorkOrder(workOrderOtherPriceIds: $workOrderOtherPriceIds) {
            data
            result
            message
            validation {
                property
                message
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);

export const gqlWorkOrderSeasons = graphql(`
    query uerWorkOrderSeasons($workOrderId: Long!) {
        uerWorkOrderSeasons(workOrderId: $workOrderId) {
            items {
                id
                year
            }
        }
    }
`);

export const gqlWorkOrderPriceListRatio = graphql(`
    query uerWorkOrderPriceListRatio($workOrderPriceId: Long!, $where: PriceListRatioRowDataFilterInput) {
        uerWorkOrderPriceListRatio(workOrderPriceId: $workOrderPriceId, where: $where) {
            items {
                appliesToCode
                appliesToCodeName
                appliesToFullName
                appliesToId
                appliesToLinkStatus
                code
                groupId
                groupIsArtificial
                groupName
                groupType
                id
                isCustom
                isIncludedInAct
                isIncludedInWorkOrder
                isIncludedInWorkOrderChange
                justification
                kem
                kmat
                knr
                kozp
                ksp
                ktz
                ktzzpm
                number
                ratioType
                status
                subGroupId
                subGroupName
                uerPriceListGroupCode
                uerPriceListGroupFullName
                uerPriceListGroupId
                uerPriceListGroupName
                uerPriceListSectionId
                uerPriceListSectionName
                workConditions
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const gqlAddRatioToWorkOrderFromPriceList = graphql(`
    mutation uerAddRatioToWorkOrderFromPriceList($workOrderPriceId: Long!, $ratioRowIds: [Long!]!) {
        uerAddRatioToWorkOrderFromPriceList(workOrderPriceId: $workOrderPriceId, ratioRowIds: $ratioRowIds) {
            data
            message
            result
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const gqlAddRatioToActKC2 = graphql(`
    mutation uerAddRatioToActKC2(
        $workOrderPriceId: Long!
        $ratioInputs: [PriceListRatioRowInput!]!
        $strategy: AddRatioToActKc2StrategyEnum!
        $actKC2Id: Long!
    ) {
        uerAddRatioToActKC2(
            workOrderPriceId: $workOrderPriceId
            ratioInputs: $ratioInputs
            strategy: $strategy
            actKC2Id: $actKC2Id
        ) {
            result
            message
            data
            validation {
                property
                message
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);

export const gqlUpdateSeasonVolume = graphql(`
    mutation uerUpdateSeasonVolume($workOrderPriceId: Long!, $workOrderSeasonId: Long!, $volume: Decimal!) {
        uerUpdateSeasonVolume(
            workOrderPriceId: $workOrderPriceId
            workOrderSeasonId: $workOrderSeasonId
            volume: $volume
        ) {
            data
            result
            message
            validation {
                property
                message
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);

export const gqlAddMtrRow = graphql(`
    mutation uerAddMtrRow($chapter: ChapterEnum, $input: PriceListMtrRowCreateInput!) {
        uerAddMtrRow(chapter: $chapter, input: $input) {
            data {
                id
            }
            result
            message
            hasValidation
            validation {
                property
                message
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);

export const uerIsUniquePriceListMtrRowKeyGql = graphql(`
    query uerIsUniquePriceListMtrRowKey($contractId: Long!, $mtrRowId: Long, $key: String) {
        uerIsUniquePriceListMtrRowKey(contractId: $contractId, mtrRowId: $mtrRowId, key: $key) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerIsUniquePriceListMtrRowCodeGql = graphql(`
    query uerIsUniquePriceListMtrRowCode(
        $contractId: Long!
        $mtrRowId: Long
        $supplyBy: ContragentTypeEnum!
        $mtrType: MtrTypeEnum!
        $inputCode: String!
    ) {
        uerIsUniquePriceListMtrRowCode(
            contractId: $contractId
            mtrRowId: $mtrRowId
            supplyBy: $supplyBy
            mtrType: $mtrType
            inputCode: $inputCode
        ) {
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const gqlCreateActKC2 = graphql(`
    mutation uerCreateActKC2($actKC2Input: ActKC2CreateInput!) {
        uerCreateActKC2(actKC2Input: $actKC2Input) {
            data {
                id
                costGroup
                status
            }
            result
            message
            hasValidation
            validation {
                message
                property
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);

export const gqlUpdateActKC2 = graphql(`
    mutation uerUpdateActKC2($actKC2Input: ActKC2UpdateInput!) {
        uerUpdateActKC2(actKC2Input: $actKC2Input) {
            data {
                id
                costGroup
                status
            }
            result
            message
            validation {
                message
                property
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);

export const gqlCopyActKC2 = graphql(`
    mutation uerCopyActKC2($actKC2Id: Long!) {
        uerCopyActKC2(actKC2Id: $actKC2Id) {
            data {
                id
                number
                date
                object {
                    name
                }
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                message
                property
            }
        }
    }
`);

export const gqlDeleteActKC2 = graphql(`
    mutation uerDeleteActKC2($actKC2Id: Long!) {
        uerDeleteActKC2(actKC2Id: $actKC2Id) {
            result
            message
            id
            validation {
                property
                message
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);

export const gqlGetActKC2 = graphql(`
    query uerActKC2($actKC2Id: Long!) {
        uerActKC2(actKC2Id: $actKC2Id) {
            data {
                isCopied
                authoredBy
                contractor
                contractorAddress
                costGroup
                createdAt
                date
                id
                isDistributionOfMtrInflation
                number
                object {
                    objectUniqueId
                    id
                    workOrderId
                    code
                    name
                    constructionType {
                        code
                        shortName
                        name
                        shortName
                        id
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    contractObject {
                        constructionType {
                            code
                            id
                            name
                            shortName
                            catalogId
                            fullName
                            contractFileName
                            createdAt
                        }
                        contractId
                        fromVOR
                        hasGuaranteedVolume
                        id
                        name
                        parentId
                        rationale
                        rootObjectId
                        status
                    }
                    fromWorkOrder
                    fromWorkOrderVOR
                    hasActsKC2
                    hasCompletedActsKC2
                    hasCompletedOtherActsKC2
                    hasCompletedSkzsActsKC2
                    hasCompletedSmrActsKC2
                    hasOngoingActsKC2
                    hasOngoingOtherActsKC2
                    hasOngoingSkzsActsKC2
                    hasOngoingSmrActsKC2
                    isActKC2Object
                    isLeaf
                    parentId
                    rootObjectId
                    workOrderId
                }
                reportingFinishDate
                reportingStartDate
                season {
                    id
                    year
                }
                inflationSeason {
                    id
                    year
                }
                status
                updatedAt
                statusFollowers
                fullNumber
                isCopied
                isCorrection
                isInactive
                correctionNumber
                correctionDate
                isSKzSCopied
                isSKzSCopyLock
                isSKzSUpdated
                canCreateCorrection
                primaryId
            }
            result
            message
            validation {
                message
                property
            }
            hasValidation
            buttonText
            hideValidation
        }
    }
`);

export const gqlWorkOrderAsExcel = graphql(`
    query uerWorkOrderExportAsExcel($workOrderId: Long!) {
        uerWorkOrderExportAsExcel(workOrderId: $workOrderId) {
            data {
                name
                dataUrl
                size
                count
            }
            message
            validation {
                message
                property
            }
            buttonText
            hasValidation
            hideValidation
            result
        }
    }
`);

export const gqlWorkOrderObjectResult = graphql(`
    query uerWorkOrderObjectResult($workOrderObjectId: Long!, $chapter: ChapterEnum, $section: SectionEnum) {
        uerWorkOrderObjectResult(workOrderObjectId: $workOrderObjectId, chapter: $chapter, section: $section) {
            title
            chapter
            section
            objectId
            actKC2Id
            sortOrder
            costResultData {
                year
                name
                value
            }
        }
    }
`);

export const gqlApplyMtrToWorkOrderFromPriceList = graphql(`
    mutation uerApplyMtrToWorkOrderFromPriceList($workOrderPriceId: Long!, $mtrRowId: Long!) {
        uerApplyMtrToWorkOrderFromPriceList(workOrderPriceId: $workOrderPriceId, mtrRowId: $mtrRowId) {
            result
            id
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                message
                property
            }
        }
    }
`);

export const gqlWorkOrderResult = graphql(`
    query uerWorkOrderResult($workOrderId: Long!) {
        uerWorkOrderResult(workOrderId: $workOrderId) {
            seasons {
                id
                year
            }
            actKC2s {
                acceptedCostDeviation
                acceptedVolumeDeviation
                canCreateCorrection
                correctionDate
                correctionNumber
                costGroup
                date
                fullNumber
                id
                inflationSeasonId
                inflationSeasonYear
                isCorrection
                isDistributionOfMtrInflation
                isInactive
                isSKzS
                isSKzSUpdated
                number
                planCostDeviation
                planVolumeDeviation
                reportingFinishDate
                reportingStartDate
                seasonId
                seasonYear
                status
                statusSKzS
            }
            results {
                actKC2Results {
                    actKC2Id
                    value
                }
                chapter
                resultSectionId
                seasonResults {
                    seasonId
                    value
                }
                section
                sortOrder
                title
                totalCompletedCost
                totalPlanCost
                totalRemainderCost
            }
        }
    }
`);

export const gqlUerWorkOrderTotals = graphql(`
    query uerWorkOrderTotals($workOrderId: Long!) {
        uerWorkOrderTotals(workOrderId: $workOrderId) {
            data {
                isHeadLine
                name
                seasonTotals {
                    completedCost
                    planCost
                    seasonId
                }
                totalCompletedCost
                totalPlanCost
                totalRemainderCost
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const gqlSetActKC2PlanVolume = graphql(`
    mutation uerSetActKC2PlanVolume($actKC2Id: Long!, $workOrderPriceId: Long!, $volume: Decimal) {
        uerSetActKC2PlanVolume(actKC2Id: $actKC2Id, workOrderPriceId: $workOrderPriceId, volume: $volume) {
            data
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const gqlSetActKC2AcceptedVolume = graphql(`
    mutation uerSetActKC2AcceptedVolume($actKC2Id: Long!, $volume: Decimal, $workOrderPriceId: Long!) {
        uerSetActKC2AcceptedVolume(actKC2Id: $actKC2Id, workOrderPriceId: $workOrderPriceId, volume: $volume) {
            data
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const gqlIsUniqueActKC2InternalNumber = graphql(`
    query uerIsUniqueActKC2InternalNumber($workOrderObjectId: Long!, $actKC2Id: Long, $actKC2Number: Long!) {
        uerIsUniqueActKC2InternalNumber(
            workOrderObjectId: $workOrderObjectId
            actKC2Id: $actKC2Id
            actKC2Number: $actKC2Number
        ) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const gqlDeleteWorkOrder = graphql(`
    mutation uerDeleteWorkOrder($workOrderId: Long!) {
        uerDeleteWorkOrder(workOrderId: $workOrderId) {
            id
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const updateMtrToWorkOrderFromPriceListGql = graphql(`
    mutation uerUpdateMtrToWorkOrderFromPriceList($input: PriceListMtrRowUpdateInput!, $workOrderPriceId: Long!) {
        uerUpdateMtrToWorkOrderFromPriceList(input: $input, workOrderPriceId: $workOrderPriceId) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uploadWorkOrderFromRivxMutation = graphql(`
    mutation uerImportWorkOrderFromRivx($contractId: Long!, $fileContent: FileInput!) {
        uerImportWorkOrderFromRivx(contractId: $contractId, fileContent: $fileContent) {
            data {
                id
                name
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uploadWorkOrderFromXmlMutation = graphql(`
    mutation uerImportWorkOrderFromXml(
        $constructionTypeId: Int!
        $contractId: Long!
        $contractSeasonId: Long!
        $filesContent: [FileInput!]!
    ) {
        uerImportWorkOrderFromXml(
            constructionTypeId: $constructionTypeId
            contractId: $contractId
            contractSeasonId: $contractSeasonId
            filesContent: $filesContent
        ) {
            data {
                id
                name
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const addWorkOrderFromXmlMutation = graphql(`
    mutation uerAddWorkOrderFromXml(
        $workOrderId: Long!
        $constructionTypeId: Int!
        $contractSeasonId: Long!
        $filesContent: [FileInput!]!
    ) {
        uerAddWorkOrderFromXml(
            workOrderId: $workOrderId
            constructionTypeId: $constructionTypeId
            contractSeasonId: $contractSeasonId
            filesContent: $filesContent
        ) {
            data {
                id
                name
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const replaceWorkOrderFromRivxMutation = graphql(`
    mutation uerReplaceWorkOrderFromRivx($workOrderId: Long!, $fileContent: FileInput!) {
        uerReplaceWorkOrderFromRivx(workOrderId: $workOrderId, fileContent: $fileContent) {
            data {
                id
                name
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const replaceWorkOrderFromXmlMutation = graphql(`
    mutation uerReplaceWorkOrderFromXml(
        $workOrderId: Long!
        $constructionTypeId: Int!
        $contractSeasonId: Long!
        $filesContent: [FileInput!]!
    ) {
        uerReplaceWorkOrderFromXml(
            workOrderId: $workOrderId
            constructionTypeId: $constructionTypeId
            contractSeasonId: $contractSeasonId
            filesContent: $filesContent
        ) {
            data {
                id
                name
            }
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const exportActKC2AsExcelGql = graphql(`
    query uerExportActKC2AsExcel($actKC2Id: Long!) {
        uerExportActKC2AsExcel(actKC2Id: $actKC2Id) {
            data {
                count
                dataUrl
                name
                size
            }
            message
            result
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const isUniqueRatioWorkConditionsGql = graphql(`
    query uerIsUniqueRatioWorkConditions($contractId: Long!, $ratioRowId: Long, $workConditions: String!) {
        uerIsUniqueRatioWorkConditions(
            contractId: $contractId
            ratioRowId: $ratioRowId
            workConditions: $workConditions
        ) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const workOrderVersionsGql = graphql(`
    query uerWorkOrderVersions($workOrderId: Long!) {
        uerWorkOrderVersions(workOrderId: $workOrderId) {
            workOrderVersionItem {
                id
                name
                internalNumber
                signingDate
                status
            }
            workOrderChangeItem {
                id
                internalNumber
                signingDate
            }
        }
    }
`);

export const updateMtrToActKC2FromPriceList = graphql(`
    mutation uerUpdateMtrToActKC2FromPriceList($workOrderPriceId: Long!, $input: PriceListMtrRowUpdateInput!) {
        uerUpdateMtrToActKC2FromPriceList(workOrderPriceId: $workOrderPriceId, input: $input) {
            id
            result
            message
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const updateUerToActKC2FromPriceList = graphql(`
    mutation uerUpdateUerToActKC2FromPriceList($workOrderPriceId: Long!, $input: PriceListUerRowUpdateInput!) {
        uerUpdateUerToActKC2FromPriceList(workOrderPriceId: $workOrderPriceId, input: $input) {
            id
            result
            message
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const updateRatioToActKC2FromPriceList = graphql(`
    mutation uerUpdateRatioToActKC2FromPriceList($workOrderPriceId: Long!, $input: PriceListRatioRowUpdateInput!) {
        uerUpdateRatioToActKC2FromPriceList(workOrderPriceId: $workOrderPriceId, input: $input) {
            id
            result
            message
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerApplyMtrToActKC2FromPriceListGql = graphql(`
    mutation uerApplyMtrToActKC2FromPriceList($workOrderPriceId: Long!, $mtrRowId: Long!) {
        uerApplyMtrToActKC2FromPriceList(workOrderPriceId: $workOrderPriceId, mtrRowId: $mtrRowId) {
            id
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerWorkOrderDraftInfo = graphql(`
    query uerWorkOrderDraftInfo($workOrderId: Long!) {
        uerWorkOrderDraftInfo(workOrderId: $workOrderId) {
            data {
                draftCount
            }
        }
    }
`);

export const uerWorkOrderObjectSelectionListGql = graphql(`
    query uerWorkOrderObjectSelectionList(
        $order: [WorkOrderObjectSelectionDataSortInput!]
        $skip: Int
        $take: Int
        $where: WorkOrderObjectSelectionDataFilterInput
        $workOrderId: Long!
    ) {
        uerWorkOrderObjectSelectionList(
            order: $order
            skip: $skip
            take: $take
            where: $where
            workOrderId: $workOrderId
        ) {
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                codeWBS
                constructionType {
                    code
                    id
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                contractId
                fromWorkOrder
                hasActsKC2
                hasPricesOther
                hasPrices
                id
                isInUse
                isIncluded
                name
                parentId
                rationale
                rootObjectId
                status
                workOrderId
                workOrderObjectId
                fromWorkOrderVOR
                fromVOR
                hasPricesOther
                isActKC2Object
                hasGuaranteedVolume
            }
            totalCount
        }
    }
`);

export const uerWorkOrderObjectSelectionListIsIncludedGql = graphql(`
    query uerWorkOrderObjectSelectionListIsIncluded(
        $order: [WorkOrderObjectSelectionDataSortInput!]
        $skip: Int
        $take: Int
        $where: WorkOrderObjectSelectionDataFilterInput
        $workOrderId: Long!
    ) {
        uerWorkOrderObjectSelectionList(
            order: $order
            skip: $skip
            take: $take
            where: $where
            workOrderId: $workOrderId
        ) {
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            items {
                isIncluded
                id
                constructionType {
                    id
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                fromWorkOrderVOR
                fromVOR
            }
            totalCount
        }
    }
`);

export const uerCreateWorkOrderObjectGql = graphql(`
    mutation uerCreateWorkOrderObject($input: ContractObjectCreateInput!, $workOrderId: Long!) {
        uerCreateWorkOrderObject(input: $input, workOrderId: $workOrderId) {
            data {
                code
                constructionType {
                    code
                    id
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                contractObject {
                    constructionType {
                        code
                        id
                        name
                        shortName
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    contractId
                    hasGuaranteedVolume
                    id
                    name
                    parentId
                    rationale
                    rootObjectId
                    status
                }
                id
                isLeaf
                name
                parentId
                rootObjectId
                workOrderId
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerCreateWorkOrderSubObjectGql = graphql(`
    mutation uerCreateWorkOrderSubObject($input: ContractSubObjectCreateInput!, $workOrderId: Long!) {
        uerCreateWorkOrderSubObject(input: $input, workOrderId: $workOrderId) {
            data {
                code
                constructionType {
                    code
                    id
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                contractObject {
                    constructionType {
                        code
                        id
                        name
                        shortName
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    contractId
                    hasGuaranteedVolume
                    id
                    name
                    parentId
                    rationale
                    rootObjectId
                    status
                }
                id
                isLeaf
                name
                parentId
                rootObjectId
                workOrderId
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerUpdateWorkOrderObjectGql = graphql(`
    mutation uerUpdateWorkOrderObject($input: ContractObjectUpdateInput!, $workOrderId: Long!) {
        uerUpdateWorkOrderObject(input: $input, workOrderId: $workOrderId) {
            data {
                code
                constructionType {
                    code
                    id
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                contractObject {
                    constructionType {
                        code
                        id
                        name
                        shortName
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    contractId
                    hasGuaranteedVolume
                    id
                    name
                    parentId
                    rationale
                    rootObjectId
                    status
                }
                id
                isLeaf
                name
                parentId
                rootObjectId
                workOrderId
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerUpdateWorkOrderSubObjectGql = graphql(`
    mutation uerUpdateWorkOrderSubObject($input: ContractObjectUpdateInput!, $workOrderId: Long!) {
        uerUpdateWorkOrderSubObject(input: $input, workOrderId: $workOrderId) {
            data {
                code
                constructionType {
                    code
                    id
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                contractObject {
                    constructionType {
                        code
                        id
                        name
                        shortName
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    contractId
                    hasGuaranteedVolume
                    id
                    name
                    parentId
                    rationale
                    rootObjectId
                    status
                }
                id
                isLeaf
                name
                parentId
                rootObjectId
                workOrderId
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerIsUniqueContractObjectNameGql = graphql(`
    query uerIsUniqueContractObjectName(
        $constructionTypeId: Int!
        $contractId: Long!
        $contractObjectId: Long
        $name: String!
    ) {
        uerIsUniqueContractObjectName(
            constructionTypeId: $constructionTypeId
            contractId: $contractId
            contractObjectId: $contractObjectId
            name: $name
        ) {
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerIsUniqueContractSubObjectNameGql = graphql(`
    query uerIsUniqueContractSubObjectName($contractObjectId: Long!, $contractSubObjectId: Long, $name: String!) {
        uerIsUniqueContractSubObjectName(
            contractObjectId: $contractObjectId
            contractSubObjectId: $contractSubObjectId
            name: $name
        ) {
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerIsUniqueContractObjectCodeGql = graphql(`
    query uerIsUniqueContractObjectCode($contractId: Long!, $contractObjectId: Long, $code: String) {
        uerIsUniqueContractObjectCode(contractId: $contractId, contractObjectId: $contractObjectId, code: $code) {
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerRemoveWorkOrderObjectGql = graphql(`
    mutation uerRemoveWorkOrderObject($contractObjectId: Long!, $workOrderId: Long!) {
        uerRemoveWorkOrderObject(contractObjectId: $contractObjectId, workOrderId: $workOrderId) {
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerIncludeContractObjectToWorkOrderGql = graphql(`
    mutation uerIncludeContractObjectToWorkOrder($contractObjectId: Long!, $workOrderId: Long!) {
        uerIncludeContractObjectToWorkOrder(contractObjectId: $contractObjectId, workOrderId: $workOrderId) {
            data
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerExcludeContractObjectFromWorkOrderGql = graphql(`
    mutation uerExcludeContractObjectFromWorkOrder($contractObjectId: Long!, $workOrderId: Long!) {
        uerExcludeContractObjectFromWorkOrder(contractObjectId: $contractObjectId, workOrderId: $workOrderId) {
            data
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerUpdateWorkOrderPriceRationaleGql = graphql(`
    mutation uerUpdateWorkOrderPriceRationale($workOrderPriceId: Long!, $input: WorkOrderPriceRationaleUpdateInput!) {
        uerUpdateWorkOrderPriceRationale(workOrderPriceId: $workOrderPriceId, input: $input) {
            message
            result
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const uerUpdateWorkOrderOtherPriceRationaleGql = graphql(`
    mutation uerUpdateWorkOrderOtherPriceRationale(
        $workOrderOtherPriceId: Long!
        $input: WorkOrderOtherPriceRationaleUpdateInput!
    ) {
        uerUpdateWorkOrderOtherPriceRationale(workOrderOtherPriceId: $workOrderOtherPriceId, input: $input) {
            message
            result
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const uerExportWorkOrderPricesGql = graphql(`
    query uerExportWorkOrderPrices($workOrderId: Long!) {
        uerExportWorkOrderPrices(workOrderId: $workOrderId) {
            data {
                count
                dataUrl
                name
                size
            }
            result
            message
            code
            buttonText
            hideValidation
            hasValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerCreateActKC2CorrectionGql = graphql(`
    mutation uerCreateActKC2Correction($primaryActKC2Id: Long!) {
        uerCreateActKC2Correction(primaryActKC2Id: $primaryActKC2Id) {
            actionRequired
            buttonText
            code
            data {
                authoredBy
                contractor
                contractorAddress
                correctionDate
                correctionNumber
                costGroup
                createdAt
                date
                fullNumber
                id
                inflationSeason {
                    id
                    year
                }
                isCopied
                isCorrection
                isDistributionOfMtrInflation
                isInactive
                number
                object {
                    code
                    constructionType {
                        code
                        id
                        name
                        shortName
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    contractObject {
                        constructionType {
                            code
                            id
                            name
                            shortName
                            catalogId
                            fullName
                            contractFileName
                            createdAt
                        }
                        contractId
                        fromVOR
                        hasGuaranteedVolume
                        id
                        name
                        parentId
                        rationale
                        rootObjectId
                        status
                    }
                    fromWorkOrder
                    fromWorkOrderVOR
                    id
                    isLeaf
                    name
                    parentId
                    rootObjectId
                    workOrderId
                    objectUniqueId
                }
                reportingFinishDate
                reportingStartDate
                season {
                    id
                    year
                }
                status
                statusFollowers
                updatedAt
                isSKzSUpdated
                isSKzSCopied
                isSKzSCopyLock
            }
            hasValidation
            hideValidation
            message
            result
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const uerUpdateActKC2CorrectionGql = graphql(`
    mutation uerUpdateActKC2Correction($input: ActKC2CorrectionUpdateInput!) {
        uerUpdateActKC2Correction(input: $input) {
            actionRequired
            buttonText
            code
            data {
                authoredBy
                contractor
                contractorAddress
                correctionDate
                correctionNumber
                costGroup
                createdAt
                date
                fullNumber
                id
                inflationSeason {
                    id
                    year
                }
                isCopied
                isCorrection
                isDistributionOfMtrInflation
                isInactive
                number
                object {
                    code
                    constructionType {
                        code
                        id
                        name
                        shortName
                        catalogId
                        fullName
                        contractFileName
                        createdAt
                    }
                    contractObject {
                        constructionType {
                            code
                            id
                            name
                            shortName
                            catalogId
                            fullName
                            contractFileName
                            createdAt
                        }
                        contractId
                        fromVOR
                        hasGuaranteedVolume
                        id
                        name
                        parentId
                        rationale
                        rootObjectId
                        status
                    }
                    fromWorkOrder
                    fromWorkOrderVOR
                    id
                    isLeaf
                    name
                    parentId
                    rootObjectId
                    workOrderId
                }
                reportingFinishDate
                reportingStartDate
                season {
                    id
                    year
                }
                status
                statusFollowers
                updatedAt
            }
            hasValidation
            hideValidation
            message
            result
            validation {
                property
                message
                metadata
            }
        }
    }
`);

export const catalogWorkTypesGql = graphql(`
    query catalogWorkTypes(
        $order: [CatalogWorkTypeDataSortInput!]
        $skip: Int
        $take: Int
        $where: CatalogWorkTypeDataFilterInput
    ) {
        catalogWorkTypes(order: $order, skip: $skip, take: $take, where: $where) {
            items {
                code
                hasPrice
                id
                name
                uniqueId
                unit
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerSetWorkOrderWorkRatioGql = graphql(`
    mutation uerSetWorkOrderWorkRatio($ratio: Decimal, $workOrderPriceId: Long!) {
        uerSetWorkOrderWorkRatio(ratio: $ratio, workOrderPriceId: $workOrderPriceId) {
            actionRequired
            buttonText
            code
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerUpdateWorkOrderSeasonsGql = graphql(`
    mutation uerUpdateWorkOrderSeasons($input: WorkOrderSeasonsInput!, $workOrderId: Long!) {
        uerUpdateWorkOrderSeasons(input: $input, workOrderId: $workOrderId) {
            actionRequired
            buttonText
            code
            data {
                firstContractSeasonId
                lastContractSeasonId
            }
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerWorkOrderPriceItemsGql = graphql(`
    query uerWorkOrderPriceItems(
        $skip: Int
        $take: Int
        $workOrderId: Long!
        $constructionTypeId: Int!
        $where: WorkOrderPriceItemFilterInput
    ) {
        uerWorkOrderPriceItems(
            skip: $skip
            take: $take
            workOrderId: $workOrderId
            constructionTypeId: $constructionTypeId
            where: $where
        ) {
            totalCount
            items {
                clientId
                itemId
                type
                sortPart
                sortSMRPart
                sortOtherPart
                rootObjectId
                rootObjectName
                objectId
                objectName
                chapter
                status
                statusTip
                entryId
                code
                name
                unit
                unitCost
                uerId
                uerCode
                uerCodeId
                entityTypeId
                entityTypeUniqueId
                entityTypeName
                hasDuplicates
                calculatingType
                calculatingTypeValue
                hasLimitSpan
                isActKC2Price
                isExcludedPrice
                rationale
                isRootObject
                isSMRItem
                isOtherGroup
                isOtherItem
                isCreatedFromSKzS
                workCode
                workName
                workUnit
                workInSum
                workRatio
                workKindWorkRatio
                workPlan
                workCompleted
                workReminder
                seasonValues {
                    itemTip
                    priceId
                    seasonId
                    seasonYear
                    planVolume
                    planTerms
                    planCost
                    completedVolume
                    completedCost
                    remainderCost
                    remainderVolume
                    hasErrors
                    errors
                    actValues {
                        actId
                        actStatus
                        actCostGroup
                        isCorrection
                        isInactive
                        actHasEditableCost
                        isActKC2DistributionOfMtrInflation
                        actInflationSeasonId
                        actVolumePlan
                        actVolumePlanDeviation
                        actVolumeAccepted
                        actVolumeAcceptedDeviation
                        actVolumeIsReadOnly
                        actCostPlan
                        actCostPlanDeviation
                        actCostAccepted
                        actCostAcceptedDeviation
                        isSKzS
                        actStatusSKzS
                        actVolumePlanSKzS
                        comment
                        isSKzSUpdated
                        isSKzSCopied
                        isSKzSCopyLock
                        actFormula
                        actFormulaDisplayText
                        actFormulaErrors
                        hasActFormula
                    }
                }
                hasEmptySeasonVolume
                hasEmptyActPlanVolume
                hasEmptyActAcceptedVolume
                hasEmptyActPlanCost
                hasEmptyActAcceptedCost
                hasOngoingOtherActs
                hasOngoingSmrActs
                hasOngoingSkzsActs
                hasCompletedSmrActs
                hasCompletedSkzsActs
                hasCompletedOtherActs
                totalPlanVolume
                totalPlanCost
                totalCompletedVolume
                totalCompletedCost
                totalRemainderVolume
                totalRemainderCost
                hasCompletedOtherActs
                hasCompletedSkzsActs
                hasCompletedSmrActs
            }
        }
    }
`);

export const uerWorkOrderActsGql = graphql(`
    query uerWorkOrderActs($workOrderId: Long!, $constructionTypeId: Int!, $where: WorkOrderActKC2DataFilterInput) {
        uerWorkOrderActs(workOrderId: $workOrderId, constructionTypeId: $constructionTypeId, where: $where) {
            items {
                objectId
                planVolumeDeviation
                acceptedVolumeDeviation
                planCostDeviation
                acceptedCostDeviation
                canCreateCorrection
                id
                number
                date
                reportingStartDate
                reportingFinishDate
                costGroup
                status
                seasonYear
                seasonId
                inflationSeasonYear
                inflationSeasonId
                isDistributionOfMtrInflation
                isCorrection
                isInactive
                correctionNumber
                fullNumber
                correctionDate
                isSKzS
                statusSKzS
                isSKzSUpdated
                isSKzSCopyLock
                isSKzSCopied
                objectId
            }
        }
    }
`);

export const uerWorkOrderSKzSInfoGql = graphql(`
    query uerWorkOrderSKzSInfo($workOrderId: Long!) {
        uerWorkOrderSKzSInfo(workOrderId: $workOrderId) {
            actionRequired
            buttonText
            code
            data {
                actsKC2SKzSNewCount
                actsKC2SKzSUpdatedCount
            }
            hasValidation
            hideValidation
            message
            result
            validation {
                message
                metadata
                property
            }
        }
    }
`);

export const uerSetActKC2WorkVolumeCommentGql = graphql(`
    mutation uerSetActKC2WorkVolumeComment($actKC2Id: Long!, $priceId: Long!, $comment: String) {
        uerSetActKC2WorkVolumeComment(actKC2Id: $actKC2Id, priceId: $priceId, comment: $comment) {
            result
            message
            validation {
                message
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);

export const uerSetActKC2OtherCostCommentGql = graphql(`
    mutation uerSetActKC2OtherCostComment($actKC2Id: Long!, $otherPriceId: Long!, $comment: String) {
        uerSetActKC2OtherCostComment(actKC2Id: $actKC2Id, otherPriceId: $otherPriceId, comment: $comment) {
            result
            message
            validation {
                message
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);

export const uerActsKC2AnalyticsByUerGql = graphql(`
    query uerActsKC2AnalyticsByUer(
        $order: [ActKC2UerCostChartDataSortInput!]
        $skip: Int
        $take: Int
        $where: ActKC2UerCostChartDataFilterInput
        $workOrderId: Long!
        $workOrderRootObjectId: Long!
    ) {
        uerActsKC2AnalyticsByUer(
            order: $order
            skip: $skip
            take: $take
            where: $where
            workOrderId: $workOrderId
            workOrderRootObjectId: $workOrderRootObjectId
        ) {
            items {
                rimActKC2WorkCost
                skzsActKC2WorkCost
                uerCode
                uerName
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerActsKC2AnalyticsBySeasonsGql = graphql(`
    query uerActsKC2AnalyticsBySeasons(
        $seasonYear: Short
        $skip: Int
        $take: Int
        $where: ActKC2UerCostPlotDataFilterInput
        $workOrderId: Long!
        $workOrderRootObjectId: Long!
    ) {
        uerActsKC2AnalyticsBySeasons(
            seasonYear: $seasonYear
            skip: $skip
            take: $take
            where: $where
            workOrderId: $workOrderId
            workOrderRootObjectId: $workOrderRootObjectId
        ) {
            items {
                rimActKC2WorkCost
                skzsActKC2WorkCost
                date
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerCreateContractSubObjectGql = graphql(`
    mutation uerCreateContractSubObject($contractId: Long!, $input: ContractSubObjectCreateInput!) {
        uerCreateContractSubObject(contractId: $contractId, input: $input) {
            result
            data {
                constructionType {
                    code
                    id
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                contractId
                fromVOR
                hasGuaranteedVolume
                id
                name
                parentId
                rationale
                rootObjectId
                status
            }
            message
            validation {
                message
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);

export const uerUpdateContractObjectGql = graphql(`
    mutation uerUpdateContractObject($contractId: Long!, $input: ContractObjectUpdateInput!) {
        uerUpdateContractObject(contractId: $contractId, input: $input) {
            result
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerUpdateContractSubObjectGql = graphql(`
    mutation uerUpdateContractSubObject($contractId: Long!, $input: ContractSubObjectUpdateInput!) {
        uerUpdateContractSubObject(contractId: $contractId, input: $input) {
            result
            data {
                constructionType {
                    code
                    id
                    name
                    shortName
                    catalogId
                    fullName
                    contractFileName
                    createdAt
                }
                contractId
                fromVOR
                hasGuaranteedVolume
                id
                name
                parentId
                rationale
                rootObjectId
                status
            }
            message
            validation {
                message
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);

export const uerRemoveWorkOrderPriceItemsGql = graphql(`
    mutation uerRemoveWorkOrderPriceItems(
        $workOrderId: Long!
        $workOrderPriceIds: [Long!]!
        $workOrderOtherPriceIds: [Long!]!
    ) {
        uerRemoveWorkOrderPriceItems(
            workOrderId: $workOrderId
            workOrderPriceIds: $workOrderPriceIds
            workOrderOtherPriceIds: $workOrderOtherPriceIds
        ) {
            result
            data {
                count
            }
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerWorkOrderObjectTotalsGql = graphql(`
    query uerWorkOrderObjectTotals($workOrderId: Long!, $workOrderObjectId: Long!) {
        uerWorkOrderObjectTotals(workOrderId: $workOrderId, workOrderObjectId: $workOrderObjectId) {
            result
            data {
                isHeadLine
                name
                seasonTotals {
                    completedCost
                    planCost
                    seasonId
                }
                totalCompletedCost
                totalPlanCost
                totalRemainderCost
            }
            message
            validation {
                message
            }
            buttonText
            hasValidation
            hideValidation
        }
    }
`);

export const uerPriceListRatioRowsWithScopesGql = graphql(`
    query uerPriceListRatioRowsWithScopes(
        $contractId: Long!
        $order: [PriceListUerRatioRowSortInput!]
        $skip: Int
        $take: Int
        $uerBaseRowId: Long!
        $where: PriceListUerRatioRowFilterInput
    ) {
        uerPriceListRatioRowsWithScopes(
            contractId: $contractId
            order: $order
            skip: $skip
            take: $take
            uerBaseRowId: $uerBaseRowId
            where: $where
        ) {
            items {
                code
                groupId
                groupName
                id
                kem
                kmat
                knr
                kozp
                ksp
                ktz
                ktzzpm
                ratioType
                status
                workConditions
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerApplyPriceListUerRatioRowsGql = graphql(`
    mutation uerApplyPriceListUerRatioRows($ratioRowIds: [Long!]!, $uerBaseRowId: Long!) {
        uerApplyPriceListUerRatioRows(ratioRowIds: $ratioRowIds, uerBaseRowId: $uerBaseRowId) {
            result
            data {
                count
            }
            message
            buttonText
            hasValidation
            hideValidation
            validation {
                property
                message
            }
        }
    }
`);

export const uerActKC2SmrPriceItemsGql = graphql(`
    query uerActKC2SmrPriceItems($skip: Int, $take: Int, $actKC2Id: Long!, $where: ActKC2SmrPriceItemFilterInput) {
        uerActKC2SmrPriceItems(skip: $skip, take: $take, actKC2Id: $actKC2Id, where: $where) {
            items {
                code
                costAccepted
                itemId
                name
                objectId
                unit
                unitCost
                volumeAccepted
                type
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerActKC2OtherPriceItemsGql = graphql(`
    query uerActKC2OtherPriceItems($actKC2Id: Long!, $skip: Int, $take: Int, $where: ActKC2OtherPriceItemFilterInput) {
        uerActKC2OtherPriceItems(skip: $skip, take: $take, actKC2Id: $actKC2Id, where: $where) {
            items {
                calculatingType
                calculatingTypeValue
                costAccepted
                itemId
                name
                objectId
                type
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerActKC2SmrTotalsGql = graphql(`
    query uerActKC2SmrTotals($actKC2Id: Long!, $skip: Int, $take: Int, $where: ActKC2TotalItemFilterInput) {
        uerActKC2SmrTotals(actKC2Id: $actKC2Id, skip: $skip, take: $take, where: $where) {
            items {
                name
                sortOrder
                totalCost
                isHeadLine
                isActKC2Total
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);

export const uerActKC2OtherTotalsGql = graphql(`
    query uerActKC2OtherTotals($actKC2Id: Long!, $skip: Int, $take: Int, $where: ActKC2TotalItemFilterInput) {
        uerActKC2OtherTotals(actKC2Id: $actKC2Id, skip: $skip, take: $take, where: $where) {
            items {
                name
                sortOrder
                totalCost
                isHeadLine
                isActKC2Total
            }
            pageInfo {
                hasNextPage
                hasPreviousPage
            }
            totalCount
        }
    }
`);
